
import clsx from 'clsx';
import { Badge } from '../../../components/ui/badge';

const STATUS_CLASSES = {
  PASSED: 'border-green-200 bg-green-100 text-green-800',
  FAILED: 'border-red-200 bg-red-100 text-red-800',
  FLAGGED: 'border-orange-200 bg-orange-100 text-orange-800',
  PENDING: 'border-yellow-200 bg-yellow-100 text-yellow-800'
};

const BiometricsStatus = ({ results }) => {
  if (!results || typeof results !== 'object') {
    return '-';
  }

  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(results).map(([key, value]) => (
        <Badge
          key={key}
          variant="outline"
          className={clsx(
            STATUS_CLASSES[value] ??
              'border-slate-200 bg-slate-100 text-slate-700'
          )}
        >
          {key.replace(/-/g, ' ').toUpperCase()}: {value}
        </Badge>
      ))}
    </div>
  );
};

export default BiometricsStatus;